import { useEffect } from "react";

const SITE_URL = "https://gourmandise-traiteur.fr";
const SITE_NAME = "Maison Désir & Gourmandise";

function upsertMeta(selector, attrs) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const key = selector.includes("property") ? "property" : "name";
    el.setAttribute(key, selector.match(/["']([^"']+)["']/)[1]);
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
}

export default function SEO({ title, description, path = "/", jsonLd = null, noindex = false }) {
  useEffect(() => {
    const fullTitle = title;
    document.title = fullTitle;
    upsertMeta('meta[name="description"]', { content: description });
    upsertMeta('meta[property="og:title"]', { content: fullTitle });
    upsertMeta('meta[property="og:description"]', { content: description });
    upsertMeta('meta[property="og:url"]', { content: `${SITE_URL}${path}` });
    upsertMeta('meta[property="og:type"]', { content: "website" });
    upsertMeta('meta[name="robots"]', { content: noindex ? "noindex, nofollow" : "index, follow" });

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `${SITE_URL}${path}`);

    document.head.querySelectorAll("script[data-seo-jsonld]").forEach((s) => s.remove());
    if (jsonLd) {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-seo-jsonld", "true");
      script.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
  }, [title, description, path, jsonLd, noindex]);

  return null;
}
